// import moment from 'moment'
// import moment from 'moment-timezone'
import i18n from '@/lang'
import countryCodeList from './country_code'
import xid from './xid/xid.js'

let baseUrl = '/api/'
// if (process.env.NODE_ENV === 'development') {
//   baseUrl = 'http://oauth.aks.hscloud.top/api/'
//   // baseUrl = 'https://intern-voice.dkl.douwa.tech/api/'
//   // baseUrl = 'http://192.168.0.225:5000/api/'
// }

// const variable
let c = {
  // 语言值
  LanguageItem: [
    {
      label: 'English',
      value: 'en',
      name: 'en',
      label_cn: '英语'
    },
    {
      label: '简体中文',
      value: 'zh_cn',
      name: 'zh_cn',
      label_cn: '简体中文'
    }
  ],
  Status: {
    Skipped: 'skipped',
    Pending: 'pending',
    Running: 'running',
    Continue: 'continue',
    Success: 'success',
    Failure: 'failure',
    Killed: 'killed',
    Error: 'error',
    Blocked: 'blocked',
    Declined: 'declined',
    Break: 'break'
  },
  MqttContextTypes: ['json', 'base64', 'hex', 'plaintext']
}

// api url
let api = {
  provider: baseUrl + 'provider/',
  auth: baseUrl + 'auth/',
  login: baseUrl + 'auth/login/',
  apps: baseUrl + 'apps/',
  app: baseUrl + 'app/',
  roles: baseUrl + 'app/roles/',
  role: baseUrl + 'app/role/',
  perms: baseUrl + 'app/perms/',
  perm: baseUrl + 'app/perm/',
  groups: baseUrl + 'app/groups/',
  group_childs: baseUrl + 'app/group/childs/',
  group: baseUrl + 'app/group/',
  appusers: baseUrl + 'app/users/',
  appuser: baseUrl + 'app/user/',
  users: baseUrl + 'users/',
  user: baseUrl + 'user/',
  logout: baseUrl + 'auth/logout/',
  applay: baseUrl + 'app',
  appgroups: baseUrl + 'current/app_user/',
  current_users_perms: baseUrl + 'current/app/perms/',
  current_users_groups: baseUrl + 'current/app/groups/',
  curren_access_tokens: baseUrl + 'current/access_tokens/',
  current_access_token: baseUrl + 'current/access_token/',
  current_password_change: baseUrl + 'current/password/change/',
  current_password_setting: baseUrl + 'current/password/setting/',
  currentUsers: baseUrl + 'current/user/',
  forgetPsssword: baseUrl + 'password/forget',
  resetPsssword: baseUrl + 'password/reset',
  resetPssswordEmail: baseUrl + 'password/reset_by_email',
  banUser: baseUrl + 'app/user/status/',
  sendEmailNumber: baseUrl + 'email/send_valid_number/',
  bindEmail: baseUrl + 'email/bind_email/',
  getApprovalData: baseUrl + 'register/approval_users/',
  modifyApprovalStatus: baseUrl + 'register/status/',
  getSingleApprovalData: baseUrl + 'register/approval_user/',
  createApprovalData: baseUrl + 'register/create/',
  createUser: baseUrl + 'create_user/',
  validUserName: baseUrl + 'get_user_by_username/',
  deleteWechat: baseUrl + 'provider/delete_wechat',
  createWechat: baseUrl + 'provider/create_wechat/',
  corsToken: '/test/cors_token/',
  cppCountry: '/cpp/oauth/country/',
  cppDpp: '/cpp/oauth/dpp/'
}

function formatToDate (createdTime) {
  // return moment.utc(createdTime).tz('Asia/Shanghai').format('YYYY-MM-DD')
}

function formatToTime (createdTime) {
  // return moment.utc(createdTime).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss')
}

function formatTime (createdTime, formatStr) {
  // return moment.utc(createdTime).tz('Asia/Shanghai').format(formatStr)
}

function convertUTCTimeToLocalTime (UTCDateString) {
  if (!UTCDateString) {
    return '-'
  }
  // 格式化显示
  function formatFunc (str) {
    return str > 9 ? str : '0' + str
  }
  // 这步是关键
  var date2 = new Date(UTCDateString)
  var year = date2.getFullYear()
  var mon = formatFunc(date2.getMonth() + 1)
  var day = formatFunc(date2.getDate())
  var hour = date2.getHours()
  var noon = hour >= 12 ? 'PM' : 'AM'
  hour = hour >= 12 ? hour - 12 : hour
  hour = formatFunc(hour)
  var min = formatFunc(date2.getMinutes())
  var dateStr =
    year + '-' + mon + '-' + day + ' ' + noon + ' ' + hour + ':' + min
  return dateStr
}

const pickerOptions = {
  shortcuts: [
    {
      text: i18n.t('message.latest_week'),
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('message.latest_month'),
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('message.last_three_months'),
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

function deepCopy (obj) {
  if (!obj) return
  var newObj
  try {
    newObj = obj.constructor && obj.constructor === Array ? [] : {}
    newObj.constructor = obj.constructor
  } catch (e) {
    newObj = []
  }
  if (typeof obj !== 'object') {
    return
  } else {
    for (var prop in obj) {
      if (!obj[prop] || obj[prop].constructor === RegExp || obj[prop].constructor === Date) {
        newObj[prop] = obj[prop]
      } else if (typeof obj[prop] === 'object') {
        // 递归
        newObj[prop] = deepCopy(obj[prop])
      } else {
        newObj[prop] = obj[prop]
      }
    }
  }
  return newObj
}

export default {
  // const variable
  c,
  // api url
  api,
  formatToDate,
  formatToTime,
  formatTime,
  convertUTCTimeToLocalTime,
  pickerOptions,
  countryCodeList,
  deepCopy,
  xid,
}



// WEBPACK FOOTER //
// ./src/utils/index.js